import React from 'react'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { withStyles } from '@material-ui/core'
import { SortableCard } from './components'
import styles from './styles'

const CardTitles = ({ cards, sectionId, setSections, sections }) => {
  return (
    <SortableContext
      items={cards.map(card => `card__${card.id}`)} // Use unique delimiter
      strategy={verticalListSortingStrategy}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {cards.map(card => (
          <SortableCard
            key={`card__${card.id}`}
            card={card}
            sectionId={sectionId}
            setSections={setSections}
            sections={sections}
          />
        ))}
      </div>
    </SortableContext>
  )
}

export default withStyles(styles)(CardTitles)
